import defaultBooks from "../data/books.json";

const BOOKS_KEY = "books";

export function initializeBooks() {
  if (!localStorage.getItem(BOOKS_KEY)) {
    localStorage.setItem(BOOKS_KEY, JSON.stringify(defaultBooks));
  }
}

export function getAllBooks() {
  initializeBooks();
  return JSON.parse(localStorage.getItem(BOOKS_KEY));
}

export function getBookById(id) {
  initializeBooks();
  return JSON.parse(localStorage.getItem(BOOKS_KEY)).find((b) => b.id === id);
}

export function addBook(newBook) {
  initializeBooks();
  const books = JSON.parse(localStorage.getItem(BOOKS_KEY));
  books.push(newBook);
  localStorage.setItem(BOOKS_KEY, JSON.stringify(books));
}

export function deleteBook(id) {
  initializeBooks();
  const books = JSON.parse(localStorage.getItem(BOOKS_KEY)).filter((b) => b.id !== id);
  localStorage.setItem(BOOKS_KEY, JSON.stringify(books));
  return books;
}
